export const en = {
    'Sign In': 'Sign In',
    Checkout: 'Checkout',
};

export const fr = {
    'Sign In': 'Connexion',
    Checkout: 'Commander',
};
